import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { ExcessReturnsType } from 'pages/main-store/excess-returns';

export type ExcessReturnContextType = {
  setExcessReturnToUpdate: Dispatch<SetStateAction<ExcessReturnsType>>;
  excessReturnToUpdate: ExcessReturnsType;
};

export const ExcessReturnContext = createContext({} as ExcessReturnContextType);
const useExcessReturnContext = () => {
  const context = useContext(ExcessReturnContext);
  return context;
};

export default useExcessReturnContext;
